import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { LanguageCode } from 'i18n/internationalization.types';
import { getLanguageName } from 'i18n/i18n.utils';

const useRemoveLanguagesConfirmationModal = () => {
  const { openConfirmModal } = useAppModal();
  const { t, i18n } = useTranslation();

  const openRemoveLanguagesConfirmationModal = ({
    removedLanguages,
    onConfirmAsync,
  }: {
    removedLanguages: LanguageCode[];
    onConfirmAsync: () => Promise<void>;
  }) => {
    openConfirmModal({
      title: t(
        'pageAutomations.common.manageLanguagesModal.removeConfirmation.title',
      ),
      body: (
        <div>
          <p>
            {t(
              'pageAutomations.common.manageLanguagesModal.removeConfirmation.description',
            )}
          </p>
          <ul>
            {removedLanguages.map((lang) => (
              <li key={lang}>{getLanguageName(i18n.language, lang)}</li>
            ))}
          </ul>
          <p>
            {t(
              'pageAutomations.common.manageLanguagesModal.removeConfirmation.footer',
            )}
          </p>
        </div>
      ),
      confirmColor: 'danger',
      confirmLabel: t(
        'pageAutomations.common.manageLanguagesModal.removeConfirmation.confirm',
      ),
      onConfirmAsync,
    });
  };

  return { openRemoveLanguagesConfirmationModal };
};

export default useRemoveLanguagesConfirmationModal;
